export const REDUX_SAVE_LOGIN_INFO = 'REDUX_SAVE_LOGIN_INFO'
export const REDUX_DESTROY_SESSION = 'REDUX_DESTROY_SESSION'
